import React, { useState} from "react";
import {Checkbox, DialogTitle, FormControlLabel, ListSubheader} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Select  from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {v4} from "uuid";
import Charcreate from "../../_helper/charcreate";
import {displayMod} from "../../_helper/displayMod";
import Button from "@mui/material/Button";
import {rollStep} from "../../_helper/rollStep";
import {rollerSetRolled} from "../../_helper/rollBehave";
import {ResultsAdd} from "../../_api/BEResult";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import {ICharTalent} from "../../_interfaces/ICharTalent";
import {IResult} from "../../_interfaces/IResult";
import {
    s_char,
    s_char_disciplines,
    s_char_grimoirespells, s_char_inventarSpells,
    s_char_lp_changes,
    s_char_talents
} from "../../_signals/s_char";
import updChar from "../../_sig_api/updChar";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {IRollerResult} from "../../_interfaces/IRoller";
import {GrimoireSpellsCreate} from "../../_api/BEGrimoireSpells";
import {ICharGrimoireSpell} from "../../_interfaces/ICharGrimoireSpell";
import {SpellsSubscriber} from "../../_helper/DataBehaves";
import {s_app_cid, s_app_rid, s_app_sl} from "../../_signals/s_app";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

function DialogLearning({open, isOpen}: IProp) {

    const mod_rank = [...Array(16).keys()];

    const [learnTalent, setLearnTalent] = useState<ICharTalent | null>(null)
    const [learnResult, setLearnResult] = useState<IRollerResult | null>(null)
    const [learnMod, setLearnMod] = useState(0)
    const [learnUseKarma, setLearnUseKarma] = useState(false)
    const [learnSpell, setLearnSpell] = useState<ICharGrimoireSpell | null>(null)


    const rollLearn = () => {
        if (!learnTalent || !learnSpell) return

        let step = s_char_attr_step(learnTalent.attribute).value;
        step = step + learnTalent.step;
        step = step + learnMod;

        const rolled = rollStep(step, learnUseKarma, learnSpell.circle + 5);

        setLearnResult(rolled);

        rollerSetRolled(true);

        const time = new Date();
        let rolledResult: IResult = {
            id: v4(),
            cid: s_app_cid.value,
            rid: s_app_rid.value,
            name: learnSpell.name,
            nsc: s_char.value.nsc,
            sl: s_app_sl.value,
            time: time.getTime(),
            title: 'Spruch lernen ' + learnSpell.name,
            eff: '',
            addEff: '',
            step: step - learnMod,
            step_mod: learnMod,
            result: rolled.result,
            rolled: rolled.rolled,
            karma: rolled.karma,
            successes: rolled.successes,
            success: rolled.success,
            rollas: '',
            rollvs: learnSpell.circle + 5,
        };

        ResultsAdd(rolledResult);
    }

    const learn = () => {
        if (!learnSpell) return;

        let char_spells = s_char_grimoirespells.value;
        const nsc = s_char.value.nsc;
        let lp_current = s_char.value.lp_current;

        const no_lp = nsc && s_app_sl.value;


        const cost = Charcreate.raise_cost["100"][learnSpell.circle];

        if (!Array.isArray(char_spells)) char_spells = [];

        let update = false;

        if (no_lp) {
            update = true;
        } else if (cost > 0) {
            if (cost < lp_current) {
                updChar([{k: 'lp_current', v: lp_current - cost}])

                let lp_changes = s_char_lp_changes.value;
                const time = new Date().toISOString();
                const add: ICharLPChanges = {
                    id: v4(),
                    cid: s_char.value.id,
                    ts: time,
                    entry: '-' + cost + ' Spruch lernen: ' + learnSpell.name
                }
                lp_changes.unshift(add);
                s_char_lp_changes.value = lp_changes
                LPChangesCreate(add)

                update = true;
            } else alert('zu wenig lp');
        } else alert('lp kosten fehler');

        if (update) {
            char_spells.push(learnSpell);
            s_char_grimoirespells.value = char_spells
            GrimoireSpellsCreate(learnSpell)
        }
        setLearnResult(null)
        setLearnSpell(null);
        isOpen(false);
    }

    const add = (name: string) => {
        const spell = SpellsSubscriber.value.find((spell) => name === spell.name);
        const talents = s_char_talents.value;
        const learn = talents.find((s) => s.name === "Struktur Verstehen");
        if (learn && learn.step > 0 && spell) {
            let charSpell: ICharGrimoireSpell = {
                attunediff: 0,
                castdiff: spell.casting,
                circle: spell.circle,
                discipline: spell.discipline,
                id: v4(),
                name: spell.name,
                threads: spell.threads,
                weavediff: spell.weaving,
                cid: s_char.value.id,
                note:''
            }
            setLearnSpell(charSpell)
            setLearnTalent(learn)
            setLearnResult(null)
            setLearnMod(0)
        } else alert('"Struktur Verstehen" fehlt oder 0');
    }

    const filter = () => {
        const disciplines = s_char_disciplines.value;
        const invspells = s_char_inventarSpells.value;
        const spells = s_char_grimoirespells.value;
        let knownspellNames = spells.map((s) => s.name);
        let disziplinen = {};
        disciplines.forEach(d => {
            disziplinen[d.name] = d.circle;
        });
        return invspells.filter((spell) => {
            return (
                disziplinen.hasOwnProperty(spell.discipline) &&
                spell.circle <= disziplinen[spell.discipline] &&
                !knownspellNames.includes(spell.name)
            );
        });
    }

    return <Dialog open={open}>
        <DialogTitle>Spruch lernen</DialogTitle>
        <DialogContent>
            <Select value={learnSpell ? learnSpell.name : ''}
                    style={{width: "100%"}}
                    onChange={(e) => add(e.target.value)}
                    variant="standard"
            >
                {filter().map(spell => <MenuItem key={v4()} value={spell.name}>
                    {spell.name} Kreis: {spell.circle} {spell.discipline}
                </MenuItem>)}
            </Select>
            {(learnSpell) ?
                <div>
                    <div>{learnSpell.name}</div>
                    <div>Schwierigkeit: {learnSpell.circle + 5}</div>
                    <div>LP
                        Kosten: {Charcreate.raise_cost["100"][learnSpell.circle]}</div>
                </div>
                : null}
            {(learnSpell) ?
                <div>
                    <div>{learnSpell.name}</div>
                    <div>Struktur Verstehen Rang: {learnTalent?.step}</div>
                    <div>Attribut: {learnTalent?.attribute}</div>
                    {learnTalent?.karma ? <FormControlLabel
                        label="Karma"
                        control={
                            <Checkbox
                                checked={learnUseKarma}
                                onChange={(e) => setLearnUseKarma(e.target.checked)}
                            />
                        }
                    /> : null}
                    <Select key={v4()}
                            value={learnMod}
                            onChange={(e) => setLearnMod(e.target.value as number)}
                    >
                        <ListSubheader>Modifikator</ListSubheader>
                        {mod_rank.map(r => <MenuItem key={v4()} value={r}>{r}</MenuItem>)}
                    </Select>
                    <Button onClick={() => rollLearn()}>würfeln</Button>

                </div>
                : null}

            {(learnResult && learnSpell) ? <div>
                    <div>Stufe: {learnResult.step} Ergebnis: {learnResult.result}</div>
                    <div>Gewürfelt: {learnResult.rolled} {displayMod(learnResult.step_mod)}
                        {learnResult.karma ? ' Karma ' + learnResult.karma : ''}
                    </div>
                    {learnResult.result >= learnSpell.circle + 5 ?
                        <Button onClick={() => learn()}>gelernt, in grimoir eintragen</Button>
                        : null
                    }
                </div>
                : null}
        </DialogContent>
        <DialogActions>
            <Button onClick={() => isOpen(false)}>beenden</Button>
        </DialogActions>
    </Dialog>

}

export default DialogLearning;